<div class="o-layout__header c-header show">
    <div class="c-header__row">

        <div class="c-header__group">

            <h2 class="c-header__heading u-heading">Fleet operations</h2>

        </div>

        <div class="c-header__group">

            <label class="c-entry-select">
                <select name="" id="">
                    <option value="">All status</option>
                    <option value="">Docked</option>
                    <option value="">In transit</option>
                    <option value="">Anchored</option>
                </select>
                <span class="c-entry-select__arrow icon-arrow-down"></span>
            </label>

        </div>
        <div class="c-header__group u-flex">

            <p class="u-text">Last update: 30/08/2025 14:51:28</p>
            <button class="c-icon-btn" aria-label="Update">
                <span class="fa fa-arrows-rotate"></span>
            </button>

        </div>
    </div> <!-- .c-header__row -->
</div> <!-- .c-header -->


<div class="c-fleet-ops o-grid u-push-t--xl" style="--grid-cols-xs: 1;--grid-cols-sm: 2;--grid-cols-md: 3;">
    <div class="o-grid-col">

        <div class="c-fleet-ops__item c-voyage u-card">

            <div class="c-voyage__top">
                <h2 class="c-voyage__heading u-heading">
                    <small class="c-voyage__vessel">RSC Caribe</small>
                    Voyage 00137
                </h2>
                <span class="c-tag context:warning">In transit</span>

                <p class="c-voyage__location c-voyage__data">
                    <i class="fa-regular fa-location-dot"></i>
                    Manzanillo, PA → Port-au-Prince, HT
                </p>
            </div>


            <ul class="c-voyage__data">
                <li>
                    <i class="fa-regular fa-calendar"></i>
                    ETA: <strong>24-10-2025 12:47 (UTC -6)</strong>
                </li>
                <li class="context:error">
                    <i class="fa-regular fa-calendar-exclamation"></i>
                    Delayed: +3 days
                </li>
            </ul>

            <ul class="c-voyage__data">
                <li class="c-voyage-progress">

                    <p class="c-voyage-progress__title">
                        Lanes used <strong>293/484 (35%)</strong>
                    </p>
                    <div class="c-voyage-progress__progress c-progress-bar c-progress-bar--xs" style="--progress: 0.4">
                        <div class="c-progress-bar__bar"></div>
                    </div>

                </li>
                <li class="c-voyage-progress">

                    <p class="c-voyage-progress__title">
                        Tons used <strong>293/484 (35%)</strong>
                    </p>
                    <div class="c-voyage-progress__progress c-progress-bar c-progress-bar--xs" style="--progress: 0.6">
                        <div class="c-progress-bar__bar"></div>
                    </div>

                </li>
            </ul>

            <hr>

            <div>
                <div class="c-voyage__data c-voyage__data--border">Port activities:</div>
                <ul class="c-voyage__activities">
                    <li class="c-voyage__activity"><span class="fa-classic fa-solid fa-box-arrow-down-arrow-up"></span>
                        Loading</li>
                    <!-- <li class="c-voyage__activity"><span class="fa fa-users"></span> Crew</li> -->
                    <li class="c-voyage__activity"><span class="fa-solid fa-box-arrow-down"></span> Discharging </li>
                    <!-- <li class="c-voyage__activity"><span class="fa fa-gas-pump"></span> Refuelling</li> -->
                    <!-- <li class="c-voyage__activity"><span class="fa fa-wrench"></span> Maintainance</li> -->
                    <li class="c-voyage__activity"><span class="fa-solid fa-salad"></span> Supply</li>
                    <!-- <li class="c-voyage__activity"><span class="fa fa-droplet"></span> Water</li> -->
                </ul>
            </div>

        </div> <!-- .c-voyage -->

    </div>
    <div class="o-grid-col">


        <div class="c-fleet-ops__item c-voyage u-card">

            <div class="c-voyage__top">
                <h2 class="c-voyage__heading u-heading">
                    <small class="c-voyage__vessel">RSC Caribe</small>
                    Voyage 00137
                </h2>
                <span class="c-tag context:current">Docked</span>

                <p class="c-voyage__location c-voyage__data">
                    <i class="fa-regular fa-location-dot"></i>
                    Kingston, JM
                </p>
            </div>


            <ul class="c-voyage__data">
                <li>
                    <i class="fa-regular fa-calendar"></i>
                    ETD: <strong>24-10-2025 12:47 (UTC -6)</strong>
                </li>
                <li class="context:success">
                    <i class="fa-regular fa-calendar-check"></i>
                    Schedule On-time
                </li>
            </ul>

            <ul class="c-voyage__data">
                <li class="c-voyage-progress">

                    <p class="c-voyage-progress__title">
                        Lanes used <strong>293/484 (35%)</strong>
                    </p>
                    <div class="c-voyage-progress__progress c-progress-bar c-progress-bar--xs" style="--progress: 0.35">
                        <div class="c-progress-bar__bar"></div>
                    </div>

                </li>
                <li class="c-voyage-progress">

                    <p class="c-voyage-progress__title">
                        Tons used <strong>293/484 (35%)</strong>
                    </p>
                    <div class="c-voyage-progress__progress c-progress-bar c-progress-bar--xs" style="--progress: 0.24">
                        <div class="c-progress-bar__bar"></div>
                    </div>

                </li>
            </ul>

            <hr>

            <div>
                <div class="c-voyage__data c-voyage__data--border">Port activities:</div>
                <ul class="c-voyage__activities">
                    <li class="c-voyage__activity"><span class="fa-classic fa-solid fa-box-arrow-down-arrow-up"></span>
                        Loading</li>
                    <!-- <li class="c-voyage__activity"><span class="fa fa-users"></span> Crew</li> -->
                    <li class="c-voyage__activity"><span class="fa-solid fa-box-arrow-down"></span> Discharging </li>
                    <!-- <li class="c-voyage__activity"><span class="fa fa-gas-pump"></span> Refuelling</li> -->
                    <!-- <li class="c-voyage__activity"><span class="fa fa-wrench"></span> Maintainance</li> -->
                    <li class="c-voyage__activity"><span class="fa-solid fa-salad"></span> Supply</li>
                    <!-- <li class="c-voyage__activity"><span class="fa fa-droplet"></span> Water</li> -->
                </ul>
            </div>

        </div> <!-- .c-voyage -->

    </div>
    <div class="o-grid-col">

        <div class="c-fleet-ops__item c-voyage u-card">

            <div class="c-voyage__top">
                <h2 class="c-voyage__heading u-heading">
                    <small class="c-voyage__vessel">RSC Caribe</small>
                    Voyage 00137
                </h2>
                <span class="c-tag context:warning">In transit</span>

                <p class="c-voyage__location c-voyage__data">
                    <i class="fa-regular fa-location-dot"></i>
                    Manzanillo, PA → Port-au-Prince, HT
                </p>
            </div>


            <ul class="c-voyage__data">
                <li>
                    <i class="fa-regular fa-calendar"></i>
                    ETA: <strong>24-10-2025 12:47 (UTC -6)</strong>
                </li>
                <li class="context:error">
                    <i class="fa-regular fa-calendar-exclamation"></i>
                    Delayed: +3 days
                </li>
            </ul>

            <ul class="c-voyage__data">
                <li class="c-voyage-progress">

                    <p class="c-voyage-progress__title">
                        Lanes used <strong>293/484 (35%)</strong>
                    </p>
                    <div class="c-voyage-progress__progress c-progress-bar c-progress-bar--xs" style="--progress: 0.3">
                        <div class="c-progress-bar__bar"></div>
                    </div>

                </li>
                <li class="c-voyage-progress">

                    <p class="c-voyage-progress__title">
                        Tons used <strong>293/484 (35%)</strong>
                    </p>
                    <div class="c-voyage-progress__progress c-progress-bar c-progress-bar--xs" style="--progress: 0.4">
                        <div class="c-progress-bar__bar"></div>
                    </div>

                </li>
            </ul>

            <hr>

            <div>
                <div class="c-voyage__data c-voyage__data--border">Port activities:</div>
                <ul class="c-voyage__activities">
                    <li class="c-voyage__activity"><span class="fa-classic fa-solid fa-box-arrow-down-arrow-up"></span>
                        Loading</li>
                    <!-- <li class="c-voyage__activity"><span class="fa fa-users"></span> Crew</li> -->
                    <li class="c-voyage__activity"><span class="fa-solid fa-box-arrow-down"></span> Discharging </li>
                    <!-- <li class="c-voyage__activity"><span class="fa fa-gas-pump"></span> Refuelling</li> -->
                    <!-- <li class="c-voyage__activity"><span class="fa fa-wrench"></span> Maintainance</li> -->
                    <li class="c-voyage__activity"><span class="fa-solid fa-salad"></span> Supply</li>
                    <!-- <li class="c-voyage__activity"><span class="fa fa-droplet"></span> Water</li> -->
                </ul>
            </div>

        </div> <!-- .c-voyage -->

    </div>
</div>